import './LivePill.scss';

import React from 'react';

interface LivePillProps {
  live?: boolean;
  label?: string;
  onClick?: () => void;
}

export default function LivePill ({ live = true, label = 'LIVE', onClick }: LivePillProps) {
  const className = [
    'live-pill',
    !live ? 'live-pill--grey' : '',
    onClick ? 'live-pill--clickable' : '',
  ].filter(Boolean).join(' ');

  if (onClick) {
    return (
      <button type="button" className={className} onClick={onClick} title="Click to refresh now">
        <span className={live ? 'live-pill__dot' : 'live-pill__dot live-pill__dot--static'} />
        <span>{label}</span>
      </button>
    );
  }

  return (
    <div className={className}>
      <span className={live ? 'live-pill__dot' : 'live-pill__dot live-pill__dot--static'} />
      <span>{label}</span>
    </div>
  );
}
